module.exports = __webpack_public_path__ + "static/media/landing-tab-notifications-d.6d8decf9.svg";